import HomeTabs from './Tabs/HomeTabs.js';
import Drawer from './Drawer/Drawer.js'
import '../App.css'

// from MUI 'Mini variant drawer' example (https://mui.com/material-ui/react-drawer/#mini-variant-drawer)

export default function HomePage() {

  return (
    <div className="page-root">
      {/* The Drawer for the Home Page has some specific buttons (buttons for Home, Top 100, FIXit, etc.) */}
      <Drawer />
      <main className="page-content">
        <HomeTabs />
      </main>
    </div>
  );
}